var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.viewedIntro,
      expression: "viewedIntro"
    }],
    staticClass: "main-container"
  }, [_vm.viewedIntro && _vm.isAssessmentAcceleratorActivity() && !_vm.isAssessmentAcceleratorTesterActivity ? _c('portal', {
    attrs: {
      "to": "save-activity-button"
    }
  }, [_c('save-activity-button')], 1) : _vm._e(), _vm.viewedIntro && _vm.isAssessmentAcceleratorActivity() && !_vm.isAssessmentAcceleratorTesterActivity && _vm.assessmentAcceleratorModuleProgress ? _c('portal', {
    attrs: {
      "to": "activity-progress-bar"
    }
  }, [_c('activity-progress-bar', {
    attrs: {
      "activityHasInstructions": !!(_vm.instructions && _vm.instructions.text),
      "currentActivity": _vm.assessmentAcceleratorModuleProgress.currentActivity,
      "totalActivities": _vm.assessmentAcceleratorModuleProgress.totalActivities
    }
  })], 1) : _vm._e(), _c('div', {
    class: {
      'component-container': _vm.isAssessmentAcceleratorActivity(),
      tablet: _vm.isMobile,
      'has-progress-bar': _vm.viewedIntro && _vm.isAssessmentAcceleratorActivity() && !_vm.isAssessmentAcceleratorTesterActivity && _vm.assessmentAcceleratorModuleProgress
    }
  }, [_vm.shouldShowAccessibilityTextHelper ? _c('accessibility-text-helper') : _vm._e(), _c(_vm.activity, {
    ref: "activity",
    tag: "component",
    staticClass: "activity-template",
    scopedSlots: _vm._u([_vm.instructions && _vm.instructions.text ? {
      key: "instructions",
      fn: function (_ref) {
        var onVoiced = _ref.onVoiced;
        return [_c('activity-instructions', {
          attrs: {
            "instructions": _vm.instructions,
            "onInstructionsVoiced": onVoiced
          }
        })];
      }
    } : null], null, true)
  }, [_c(_vm.keyboardComponent, {
    tag: "component",
    attrs: {
      "slot": "keyboard"
    },
    slot: "keyboard"
  })], 1)], 1), _vm.viewedIntro && _vm.isAssessmentAcceleratorActivity() && !_vm.hasCustomNextButton ? _c('portal', {
    attrs: {
      "to": "next-activity-button"
    }
  }, [_c('next-activity-button', {
    attrs: {
      "on-click": _vm.handleOnActivitySubmit
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }